import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../geometry.js";
import { isSome as e } from "../core/maybe.js";
import r from "../geometry/SpatialReference.js";
var t;

function a() {
  return t || (t = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var e;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import("./arcadeUtils.js");

          case 2:
            e = _context.sent;
            return _context.abrupt("return", {
              arcade: e.arcade,
              arcadeUtils: e,
              Dictionary: e.Dictionary,
              Feature: e.arcadeFeature
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))()), t;
}

var s = function s(e, r, t) {
  return o.create(e, r, t, null, ["$feature"]);
},
    i = function i(e, r, t) {
  return o.create(e, r, t, null, ["$feature", "$view"]);
},
    c = i,
    n = function n(e, r, t, a) {
  return o.create(e, r, t, a, ["$feature", "$view"]);
};

var o = /*#__PURE__*/function () {
  function o(e, r, t, a, s, i, c, n) {
    _classCallCheck(this, o);

    this.script = e, this.evaluate = s;

    var _o = Array.isArray(c) ? c : c.fields;

    this.fields = _o, this._syntaxTree = a, this._arcade = r, this._arcadeDictionary = t, this._arcadeFeature = i, this._spatialReference = n, this._referencesGeometry = r.scriptTouchesGeometry(this._syntaxTree), this._referencesScale = this._arcade.referencesMember(this._syntaxTree, "scale");
  }

  _createClass(o, [{
    key: "repurposeFeature",
    value: function repurposeFeature(e) {
      return e.geometry && !e.geometry.spatialReference && (e.geometry.spatialReference = this._spatialReference), this._arcadeFeature.repurposeFromGraphicLikeObject(e.geometry, e.attributes, {
        fields: this.fields
      }), this._arcadeFeature;
    }
  }, {
    key: "repurposeAdapter",
    value: function repurposeAdapter(e) {
      return this._arcadeFeature.repurposeFromAdapter(e, {
        fields: this.fields
      }), this._arcadeFeature;
    }
  }, {
    key: "createDictionary",
    value: function createDictionary() {
      return new this._arcadeDictionary();
    }
  }, {
    key: "referencesMember",
    value: function referencesMember(e) {
      return this._arcade.referencesMember(this._syntaxTree, e);
    }
  }, {
    key: "referencesFunction",
    value: function referencesFunction(e) {
      return this._arcade.referencesFunction(this._syntaxTree, e);
    }
  }, {
    key: "referencesGeometry",
    value: function referencesGeometry() {
      return this._referencesGeometry;
    }
  }, {
    key: "referencesScale",
    value: function referencesScale() {
      return this._referencesScale;
    }
  }, {
    key: "extractFieldLiterals",
    value: function extractFieldLiterals() {
      return this._arcade.extractExpectedFieldLiterals(this._syntaxTree);
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, s, i, c, n, l) {
        var _yield$a, u, p, f, d, y, h, m, _, F, w, S, b, $, x;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return a();

              case 2:
                _yield$a = _context2.sent;
                u = _yield$a.arcade;
                p = _yield$a.Feature;
                f = _yield$a.Dictionary;
                d = r.fromJSON(s);
                y = u.parseScript(t, l);
                h = n.reduce(function (e, r) {
                  return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, r, null));
                }, {});
                m = null;
                e(c) && (m = new f(c), m.immutable = !0, h.$config = null);
                _ = u.scriptUsesGeometryEngine(y) && u.enableGeometrySupport(), F = u.scriptUsesFeatureSet(y) && u.enableFeatureSetSupport(), w = u.scriptIsAsync(y) && u.enableAsyncSupport(), S = {
                  vars: h,
                  spatialReference: d,
                  useAsync: !!w
                }, b = new f();
                b.immutable = !1, b.setField("scale", 0);
                $ = u.compileScript(y, S), x = function x(e) {
                  return "$view" in e && e.$view && (b.setField("scale", e.$view.scale), e.$view = b), m && (e.$config = m), $({
                    vars: e,
                    spatialReference: d
                  });
                };
                _context2.next = 16;
                return Promise.all([_, F, w]);

              case 16:
                return _context2.abrupt("return", new o(t, u, f, y, x, new p(), i, d));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function create(_x, _x2, _x3, _x4, _x5, _x6) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return o;
}();

export { o as ArcadeExpression, n as createDictionaryExpression, s as createLabelExpression, i as createRendererExpression, c as createVVExpression, o as default, a as loadArcade };